import { render, staticRenderFns } from "./quarter_mobile_notes.vue?vue&type=template&id=6146f768&scoped=true&"
import script from "./quarter_mobile_notes.vue?vue&type=script&lang=js&"
export * from "./quarter_mobile_notes.vue?vue&type=script&lang=js&"
import style0 from "./quarter_mobile_notes.vue?vue&type=style&index=0&id=6146f768&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6146f768",
  null
  
)

export default component.exports